export default {
  showPasswordPlaceholder: {
    id: 'FORMS_SHOW_PASSWORD_INPUT_PLACEHOLDER',
    defaultMessage: 'Show',
    description: 'placeholder for displaying password characters',
  },
};
